import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // Start of old Api
    fetchStore(ctx){
        return new Promise((resolve, reject) => {
            axiosIns.get('/store/'+getUserData().store_id)
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    addBanner(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/store_banner', data,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    // End of old Api
    // Start of new api

    fetchBanners(ctx, queryParams){
      return new Promise((resolve, reject) => {
          axiosIns.get('/banner/list', {params:queryParams})
          .then(response=>resolve(response))
          .catch(error=>reject(error))
      })
    },
    updateBanner(ctx, data) {
      return new Promise((resolve, reject) => {
          axiosIns.post('/banner', data,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
          )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteBanner(ctx, queryParams)
    {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/banner', {params:queryParams})
        .then(response=>resolve(response))
        .catch(error=>reject(error))
    })
    }




  },
}
